import React from 'react';
import { Routes, Route } from 'react-router-dom';
import GiftCardLanding from './components/GiftCardLanding';
import AdminPage from './components/AdminPage';
import './index.css';

function App() {
  return (
    <Routes>
      <Route path="/" element={<GiftCardLanding />} />
      <Route path="/admin" element={<AdminPage />} />
    </Routes>
  );
}

export default App;